import React, { useEffect, useState } from "react";
import { Alert, Modal, Spin, theme, Typography } from "antd";
import { ReleaseNoteLanguage } from "../../../../interfaces/releaseNote.interface";
import { previewReleaseNoteEmailServer } from "../../releaseNotesApi";

const { Text } = Typography;

interface EmailPreviewModalProps {
  open: boolean;
  title: string;
  body: string;
  locale: ReleaseNoteLanguage;
  onClose: () => void;
}

const EmailPreviewModal: React.FC<EmailPreviewModalProps> = ({
  open,
  title,
  body,
  locale,
  onClose,
}) => {
  const { token } = theme.useToken();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [subject, setSubject] = useState("");
  const [html, setHtml] = useState("");

  useEffect(() => {
    if (!open) return;
    let cancelled = false;
    setLoading(true);
    setError(null);
    previewReleaseNoteEmailServer({ locale, title, body })
      .then((result) => {
        if (cancelled) return;
        setSubject(result.subject);
        setHtml(result.html);
      })
      .catch(() => {
        if (!cancelled) setError("Failed to render email preview.");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [open, locale, title, body]);

  return (
    <Modal
      title="Email Preview"
      open={open}
      onCancel={onClose}
      footer={null}
      width={720}
    >
      {error ? (
        <Alert type="error" message={error} showIcon />
      ) : loading ? (
        <div style={{ textAlign: "center", padding: token.paddingLG }}>
          <Spin />
        </div>
      ) : (
        <>
          <Text type="secondary">Subject</Text>
          <div style={{ marginBottom: token.margin, fontWeight: 600 }}>
            {subject}
          </div>
          <iframe
            title="release-note-email-preview"
            srcDoc={html}
            style={{
              width: "100%",
              minHeight: 480,
              border: `1px solid ${token.colorBorder}`,
              borderRadius: token.borderRadius,
              background: "#fff",
            }}
          />
        </>
      )}
    </Modal>
  );
};

export default EmailPreviewModal;
